export const scrollToId = (id) => {
  const target = document.querySelector(id);
  if (!target) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -84, duration: 1.4 });
  } else {
    target.scrollIntoView({ behavior: "smooth" });
  }
};
